import { Header, makeUclComponent } from '@rbilabs/universal-components';

import { MarketingTileGroup } from 'components/features/components/marketing-tile-group';
import SanityBlockRenderer from 'components/sanity-block-renderer';

export const RewardsTitle = Header.withConfig({
  color: Styles.color.alert.info.background,
  fontFamily: Styles.fontFamily.brand,
  textAlign: 'center',
  accessibilityLevel: 1,
  fontSize: '3xl',
  lineHeight: 'md',
});

export const DisclaimerMessage = makeUclComponent(SanityBlockRenderer).withConfig({
  marginTop: {
    base: '$3',
    md: '$6',
  },
  marginRight: 0,
  marginBottom: {
    base: '$3',
    md: '$12',
  },
  marginLeft: 0,
  textProps: {
    color: Styles.color.black,
    textAlign: 'center',
    fontSize: {
      base: 'sm',
      md: 'md',
    },
  },
});

export const MarketingTileGroupStyled = makeUclComponent(MarketingTileGroup).withConfig({
  width: 'full',
  marginY: 0,
  paddingTop: 0,
  _marketingTileList: {
    space: '$6',
  },
  borderRadius: 0,
  shadow: 'none',
});
